/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  QueryClient,
  QueryFunctionContext,
  QueryKey,
} from "@tanstack/react-query";
import { GramCore } from "../core.js";
import { authClientsList } from "../funcs/authClientsList.js";
import { combineSignals } from "../lib/primitives.js";
import { RequestOptions } from "../lib/sdks.js";
import {
  ClientType,
  ListAuthClientsRequest,
  ListAuthClientsResponse,
  ListAuthClientsSecurity,
} from "../models/operations/listauthclients.js";
import { unwrapAsync } from "../types/fp.js";
import { PageIterator, unwrapResultIterator } from "../types/operations.js";
import { pageIteratorToJSON } from "./_types.js";
export type AuthClientsQueryData = ListAuthClientsResponse;

export type AuthClientsInfiniteQueryData = PageIterator<
  ListAuthClientsResponse,
  { cursor: string }
>;

export type AuthClientsPageParams = PageIterator<
  ListAuthClientsResponse,
  { cursor: string }
>["~next"];

export function prefetchAuthClients(
  queryClient: QueryClient,
  client$: GramCore,
  request?: ListAuthClientsRequest | undefined,
  security?: ListAuthClientsSecurity | undefined,
  options?: RequestOptions,
): Promise<void> {
  return queryClient.prefetchQuery({
    ...buildAuthClientsQuery(
      client$,
      request,
      security,
      options,
    ),
  });
}

export function prefetchAuthClientsInfinite(
  queryClient: QueryClient,
  client$: GramCore,
  request?: ListAuthClientsRequest | undefined,
  security?: ListAuthClientsSecurity | undefined,
  options?: RequestOptions,
): Promise<void> {
  return queryClient.prefetchInfiniteQuery({
    ...buildAuthClientsInfiniteQuery(
      client$,
      request,
      security,
      options,
    ),
    initialPageParam: undefined as AuthClientsPageParams,
    getNextPageParam: (previousPage: AuthClientsInfiniteQueryData) =>
      previousPage["~next"],
  });
}

export function buildAuthClientsQuery(
  client$: GramCore,
  request?: ListAuthClientsRequest | undefined,
  security?: ListAuthClientsSecurity | undefined,
  options?: RequestOptions,
): {
  queryKey: QueryKey;
  queryFn: (context: QueryFunctionContext) => Promise<AuthClientsQueryData>;
} {
  return {
    queryKey: queryKeyAuthClients({
      mcpServerId: request?.mcpServerId,
      clientType: request?.clientType,
      cursor: request?.cursor,
      limit: request?.limit,
      gramSession: request?.gramSession,
      gramKey: request?.gramKey,
    }),
    queryFn: async function authClientsQueryFn(
      ctx,
    ): Promise<AuthClientsQueryData> {
      const sig = combineSignals(
        ctx.signal,
        options?.signal,
        options?.fetchOptions?.signal,
      );
      const mergedOptions = {
        ...options?.fetchOptions,
        ...options,
        signal: sig,
      };

      return unwrapAsync(authClientsList(
        client$,
        request,
        security,
        mergedOptions,
      ));
    },
  };
}

export function buildAuthClientsInfiniteQuery(
  client$: GramCore,
  request?: ListAuthClientsRequest | undefined,
  security?: ListAuthClientsSecurity | undefined,
  options?: RequestOptions,
): {
  queryKey: QueryKey;
  queryFn: (
    context: QueryFunctionContext<QueryKey, AuthClientsPageParams>,
  ) => Promise<AuthClientsInfiniteQueryData>;
} {
  return {
    queryKey: queryKeyAuthClientsInfinite({
      mcpServerId: request?.mcpServerId,
      clientType: request?.clientType,
      cursor: request?.cursor,
      limit: request?.limit,
      gramSession: request?.gramSession,
      gramKey: request?.gramKey,
    }),
    queryFn: async function authClientsQuery(
      ctx,
    ): Promise<AuthClientsInfiniteQueryData> {
      const sig = combineSignals(ctx.signal, options?.fetchOptions?.signal);
      const mergedOptions = {
        ...options,
        fetchOptions: { ...options?.fetchOptions, signal: sig },
      };

      if (!ctx.pageParam) {
        const pageResult = await unwrapResultIterator(authClientsList(
          client$,
          request,
          security,
          mergedOptions,
        ));
        return pageIteratorToJSON(pageResult);
      }
      const pageResult = await unwrapResultIterator(authClientsList(
        client$,
        {
          ...request!,
          cursor: ctx.pageParam.cursor,
        },
        security,
        mergedOptions,
      ));
      return pageIteratorToJSON(pageResult);
    },
  };
}

export function queryKeyAuthClients(
  parameters: {
    mcpServerId?: string | undefined;
    clientType?: ClientType | undefined;
    cursor?: string | undefined;
    limit?: number | undefined;
    gramSession?: string | undefined;
    gramKey?: string | undefined;
  },
): QueryKey {
  return ["@gram/client", "authClients", "list", parameters];
}

export function queryKeyAuthClientsInfinite(
  parameters: {
    mcpServerId?: string | undefined;
    clientType?: ClientType | undefined;
    cursor?: string | undefined;
    limit?: number | undefined;
    gramSession?: string | undefined;
    gramKey?: string | undefined;
  },
): QueryKey {
  return ["@gram/client", "authClients", "list", "infinite", parameters];
}
